import { HStack, Text } from '@chakra-ui/react'
import React from 'react'
import Imagen from '../../../assets/images/Amipass3.png'

export function Felicitaciones() {
  return (
    <HStack mt={7} mb={7} gap={2}>
      <img src={Imagen} alt="amipass" />
      <Text variant="subtitle2" color="#000">
        ¡Felicitaciones! por tus gestiones y la colaboración de tu equipo estás
        aportando al cuidado del planeta!
      </Text>
    </HStack>
  )
}
